import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

const Container = styled.div`
  position: relative;
  margin: auto 24px auto auto;
  display: flex;
`;

const ColorList = styled.div`
  width: 48px;
  background-color: white;
  border-radius: 8px;
  margin-right: 12px;
  height: 216px;
  margin-top: -58px;
  padding-top: 3px;
`;

const IconBackground = styled(({ isDisabled, ...props }) => <div {...props} />)`
  height: 36px;
  width: 36px;
  border-radius: 50%;
  margin-bottom: 16px;
  background-color: #fff;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${({ isDisabled }) =>
    isDisabled &&
    `
    pointer-events: none !important;
    opacity: .45 !important;
  `}
`;

const IconContainer = styled.div`
  flex: 0 0 20px;
  min-height: 20px;
  text-align: center;
`;
const ColorIcon = styled(Icon)`
  &&& {
    color: ${(props) => props.defaultValue};
    font-size: 24px;
    margin: 6px 12px 6px 12px;
    width: 24px;
  }
`;

const ControlGroups = styled.div`
  width: 36px;
  margin-top: 18px;
`;
const ControlIcon = styled(Icon)`
  &&& {
    font-size: 14px;
    line-height: 1;
    width: 1em !important;
    margin: 0 !important;
    vertical-align: middle;
    color: ${(props) =>
      props.defaultChecked ? props.defaultValue : '#999999'};
  }
`;

export default function CanvasControl(props: any) {
  return (
    <Container>
      <ColorList>
        {props.penColors.map((color: string) => (
          <ColorIcon
            key={color}
            name="circle"
            defaultValue={color}
            onClick={() => props.setColor(color)}
          />
        ))}
      </ColorList>
      <ControlGroups>
        <IconBackground
          onClick={() =>
            props.updateMarker(props.markerName === 'circle' ? '' : 'circle')
          }
        >
          <IconContainer>
            <ControlIcon
              name="circle outline"
              defaultChecked={props.markerName === 'circle'}
              defaultValue={props.color}
            />
          </IconContainer>
        </IconBackground>
        <IconBackground
          onClick={() =>
            props.updateMarker(props.markerName === 'pencil' ? '' : 'pencil')
          }
        >
          <IconContainer>
            <ControlIcon
              name="pencil"
              defaultChecked={props.markerName === 'pencil'}
              defaultValue={props.color}
            />
          </IconContainer>
        </IconBackground>
        <IconBackground
          onClick={() => props.refreshCanvas()}
          isDisabled={props.isRefreshDisabled}
        >
          <IconContainer>
            <ControlIcon name="refresh" defaultValue="#999999" />
          </IconContainer>
        </IconBackground>
      </ControlGroups>
    </Container>
  );
}
